import { render, staticRenderFns } from "./ModalityList.vue?vue&type=template&id=f618c632&"
import script from "./ModalityList.js?vue&type=script&lang=js&"
export * from "./ModalityList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports